import { Helmet } from "react-helmet-async";

/**
 * Composant SEO réutilisable pour chaque page.
 * Met à jour dynamiquement title, description, OG, canonical, Twitter Card.
 */
export const Seo = ({
  title = "PDR France — Débosselage sans peinture (DSP) · Grêle & Smart Repair",
  description = "PDR France : spécialiste du débosselage sans peinture (DSP), grêle, Smart Repair, carrosserie aluminium & carbone. Intervention France & international, devis sous 24h.",
  path = "/",
  image = "/og-image.jpg",
  type = "website",
  noindex = false,
}) => {
  const baseUrl = "https://pdrfrance.fr";
  const url = `${baseUrl}${path}`;
  const imageUrl = image.startsWith("http") ? image : `${baseUrl}${image}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:type" content={type} />

      {/* Twitter */}
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
    </Helmet>
  );
};
